// serializer
import InvoiceItemImproveSerializer from "issara-sdk/types/InvoiceItemImproveSerializer_apps_BIL";
import ReceiptSerializer from "issara-sdk/types/ReceiptSerializer_apps_BIL";

import { amountOf } from "./billingModelV4";

// ---------- ใบเสร็จ ----------

/** แถวของ BIL/receipt/ */
export type Receipt = ReceiptSerializer;

export type HistoryFilter = {
  code: string;
  status: "" | NonNullable<Receipt["status_name"]>;
  fromDate: string;
  toDate: string;
};

export const STATUS_OPTIONS: { value: HistoryFilter["status"]; label: string }[] = [
  { value: "", label: "ทั้งหมด" },
  { value: "PAID", label: "พิมพ์แล้ว" },
  { value: "CANCELED", label: "ยกเลิก" },
];

export const emptyHistoryFilter = (today: string): HistoryFilter => ({
  code: "",
  status: "",
  fromDate: today,
  toDate: today,
});

/** ยอดรวมของใบเสร็จที่ไม่ถูกยกเลิก */
export const historyTotalOf = (receipts: Receipt[]) => {
  let total = 0;

  for (const receipt of receipts) {
    if (receipt.status_name !== "CANCELED") {
      total += amountOf(receipt.price);
    }
  }

  return total;
};

// ---------- รายการค่าบริการ ----------

/** แถวของ BIL/invoiceitem/?receipt= */
export type ReceiptItem = InvoiceItemImproveSerializer;
